export enum NAMESPACE_KEYS {
    REQUEST = "REQUEST" as any,
}
